(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text-collapse-with-link"] && !Shopify.designMode) return;
  try {
    
  function initRichTextCollapseWithLink() {
    const wrappers = document.querySelectorAll("[data-collapse-wrapper]");
    
    wrappers.forEach(wrapper => {
      const content = wrapper.querySelector("[data-collapse-content]");
      const prose = wrapper.querySelector("[data-collapse-prose]");
      const button = wrapper.querySelector("[data-collapse-btn]");
      const fade = wrapper.querySelector("[data-collapse-fade]");

      if (!content || !prose || !button) return;

      // Calcul précis basé sur le style réel calculé par le navigateur
      const computedStyle = window.getComputedStyle(prose);
      let lineHeight = parseFloat(computedStyle.lineHeight);
      
      if (isNaN(lineHeight)) {
        lineHeight = parseFloat(computedStyle.fontSize) * 1.5;
      }

      const lineLimit = parseInt(wrapper.style.getPropertyValue('--line-limit')) || 3;
      const collapsedHeight = Math.ceil(lineLimit * lineHeight);
      const totalHeight = prose.scrollHeight;

      // Ajout d'une marge de tolérance de 8px pour ignorer les arrondis de pixels et les micro-espaces
      if (totalHeight <= collapsedHeight + 8) {
        button.style.display = "none";
        if (fade) fade.style.display = "none";
        content.style.maxHeight = "none";
        return;
      }

      // Si le code n'avait pas encore été initialisé graphiquement
      if (!wrapper.hasAttribute("data-initialized")) {
        wrapper.setAttribute("data-initialized", "true");
        content.style.maxHeight = collapsedHeight + "px";

        button.addEventListener("click", function () {
          const isExpanded = content.getAttribute("aria-expanded") === "true";
          
          if (isExpanded) {
            content.setAttribute("aria-expanded", "false");
            content.style.maxHeight = collapsedHeight + "px";
            button.textContent = button.getAttribute("data-more");
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } else {
            content.setAttribute("aria-expanded", "true");
            content.style.maxHeight = prose.scrollHeight + "px";
            button.textContent = button.getAttribute("data-less");
          }
        });
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRichTextCollapseWithLink);
  } else {
    initRichTextCollapseWithLink();
  }

  document.addEventListener("shopify:section:load", initRichTextCollapseWithLink);
  document.addEventListener("shopify:block:load", initRichTextCollapseWithLink);

  } catch(e) { console.error(e); }
})();
})();
